import { Component, OnInit } from '@angular/core';
import { ToastComponent } from '../../../../core/components/toasts/toast/toast.component';
import { AlertComponent } from '../../../../core/components/alert/alert.component';
import { LoadindicatorComponent } from '../../../../core/components/loadindicator/loadindicator.component';
import { FooterComponent } from '../../ecce/footer/footer.component';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-auth-layout',
    templateUrl: './auth-layout.component.html',
    styleUrls: ['./auth-layout.component.scss'],
    imports: [RouterOutlet, FooterComponent, LoadindicatorComponent, AlertComponent, ToastComponent]
})
export class AuthLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
